module.exports = __webpack_public_path__ + "static/media/photo-selfie2.52a155ee.jpg";